import { useQueryClient } from "@tanstack/react-query"

import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

import { invalidateDocumentsList, invalidateDocumentProject, invalidateAttachedObject } from "../cacheUtils"
import { documentQueryKeys } from "../queries/queryKeys"
import { useDocumentProject } from "../queries/useDocumentProject"

import { useDocumentMutation } from "./useDocumentMutation"

export function useDocumentCreate(
    queryParameters,
    config = {},
) {
    const queryClient = useQueryClient()
    const { selectedNetwork } = useNetworksStateContext()
    const url = "documents/"

    const { data: project } = useDocumentProject()

    const axiosFn = (url, values) => {
        const formData = new FormData()
        Object.entries(values).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                formData.append(`${key}`, JSON.stringify(value))
            } else {
                formData.append(key, value)
            }
        })
        if (!values.linear_location_type_data && !values.attached_object_uuid) {
            formData.append("attached_object_uuid", selectedNetwork.uuid)
        }
        formData.append("project", project.uuid)

        const headers = { "Content-Type": "multipart/form-data" }

        return axiosInstance.post(url, formData, {
            headers: headers,
        })
    }

    return useDocumentMutation(
        url,
        axiosFn,
        queryParameters,
        {
            ...config,
            onSuccess: (data) => {
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.detail(document.uuid) })
                queryClient.invalidateQueries({ queryKey: documentQueryKeys.authors() })

                invalidateDocumentProject(queryClient, selectedNetwork)
                invalidateDocumentsList(queryClient, selectedNetwork)
                invalidateAttachedObject(queryClient, data)

                config.onSuccess?.(data)
            },
        },
    )
}
